<div class="private-policy">

<div class="contacts">

    <div class="shop-info" [innerHTML]="libraryConditions">
    </div>
</div>
</div>
